import { useEffect } from "react";
import { appStore } from "src/framework/store/AppStore";
import { ProjetoVertical } from 'src/components/projetos/verticais'
import { EdicaoLayout } from "src/components/projetos/edicao/layouts/EdicaoLayout";

const PAGE_TITLE = "Edição projeto especial";

const ProjetoVerticalEdicaoPage = () => {

  useEffect(() => {
    appStore.setPageTitle(PAGE_TITLE);
    return () => {
      appStore.setPageTitle("");
    }
  }, [])

  return (
    <EdicaoLayout>
      <div className="container">
        <div className="row">
          <div className="X12">
            <ProjetoVertical />
          </div>
        </div>
      </div>
    </EdicaoLayout>
  );
};

export { ProjetoVerticalEdicaoPage };
